import Rails from '@rails/ujs';
import $ from 'jquery';

import Trix, { removeNode } from 'trix';
import 'trix/dist/trix.css';

import * as Lib from 'jQuery/admin';
import 'controllers/admin.js';
import 'components/admin';
import 'stylesheets/admin/application.css';

require('@rails/actiontext');
require.context('images', true);

Rails.start();

$(() => {
  const $container = $(document);

  Lib.DatePicker($container);
  Lib.OptionalFields($container);
  Lib.Selectize($container);
  Lib.Autosize($container);
});

class RichText {
  constructor(element) {
    self = this;
    this.element = element;

    this.removeOriginalHeadingButton();
    this.insertNewHeadingButton();
  }

  removeOriginalHeadingButton() {
    removeNode(this.originalHeadingButton);
  }

  insertNewHeadingButton() {
    this.buttonGroupBlockTools.insertAdjacentHTML('afterbegin', this.headingButtonTemplate);
    this.buttonGroupBlockTools.insertAdjacentHTML('beforeEnd', this.headingBannersTemplate);
  }

  addBannerTemplate(input) {
    const trix = this.element.editor;

    const content = `
      <abbr>
        Banner will be right here …
      </abbr>
    `;

    return this.element.editor.insertHTML(content);
  }

  addStoriesTemplate(input) {
    const trix = this.element.editor;

    const content = `
      <address>
        Related stories will be right here …
      </address>
    `;

    return this.element.editor.insertHTML(content);
  }

  get buttonGroupBlockTools() {
    return this.toolbarElement.querySelector('[data-trix-button-group=block-tools]');
  }

  get originalHeadingButton() {
    return this.toolbarElement.querySelector('[data-trix-attribute=heading1]');
  }

  get toolbarElement() {
    return this.element.toolbarElement;
  }

  get headingButtonTemplate() {
    return `
      <button class="trix-button" data-trix-attribute="heading1">H1</button>
      <button class="trix-button" data-trix-attribute="heading2">H2</button>
      <button class="trix-button" data-trix-attribute="heading3">H3</button>
      <button class="trix-button" data-trix-attribute="heading4">H4</button>
    `;
  }

  get headingBannersTemplate() {
    return `
      <button type="button" class="trix-button" data-trix-attribute="attach" onclick="self.addBannerTemplate()">Banner</button>
      <button type="button" class="trix-button" data-trix-attribute="attach" onclick="self.addStoriesTemplate()">Stories</button>
    `;
  }
}

addEventListener('trix-initialize', function (e) {
  new RichText(e.target);
});

Array.from(['h2', 'h3', 'h4', 'h5', 'h6']).forEach((tagName, i) => {
  Trix.config.blockAttributes[`heading${i + 1}`] = {
    tagName: tagName,
    terminal: true,
    breakOnReturn: true,
    group: false,
  };
});

Trix.config.lang.captionPlaceholder = "Caption for image | Alt for img tag"

Trix.config.blockAttributes.abbr = { tagName: 'abbr' };
Trix.config.blockAttributes.address = { tagName: 'address' };

Trix.config.attachments.preview.caption.name = false;
Trix.config.attachments.preview.caption.size = false;
